import Styles from "./popup.module.css";

export default function Popup({ children, sx }) {
  return (
    <div className={Styles.themeBackground} style={sx} role="dialog" aria-modal="true">
      {children}
    </div>
  );
}
